<template>
  <div class="offer-tab">
    <FormButtons
      v-loading="showOfferLoaderShow"
      class="offer-tab__buttons"
      :buttons_menu="[[goToOfferButton]]"
      @get-preview="showPreview"
    ></FormButtons>
    <DetailViewGroupFields
      v-for="item in panels"
      :key="item.panel_id"
      :panel="item"
      :fields="bean"
      store-module="candidate"
    />
  </div>
</template>
<script>
import { store } from '@/store';
import { errorMsg, mixin } from '@/utils/mixins';
import DetailViewGroupFields from 'Elements/MetaData/DetailViewGroupFields';
import FormButtons from 'Elements/Form/FormButtons';

export default {
  mixins: [mixin, errorMsg],
  components: { FormButtons, DetailViewGroupFields },
  data() {
    return {
      showOfferLoaderShow: false
    };
  },
  computed: {
    bean() {
      return store.state.subpanels.activeSubpanelData[
        'dynamic_coordination_subpanel'
      ].bean;
    },
    panels() {
      return store.state.subpanels.activeSubpanelData[
        'dynamic_coordination_subpanel'
      ].metadata.panels;
    },
    goToOfferButton() {
      return (
        store.state.subpanels.activeSubpanelData[
          'dynamic_coordination_subpanel'
        ].metadata.top_custom_panels.preview || {}
      );
    }
  },
  methods: {
    s2ab(s) {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;

      return buf;
    },
    async showPreview(intent) {
      this.showOfferLoaderShow = true;
      const resp = await this.sendFormRequestFromIntent(intent);
      if (resp?.data) {
        const file = new Blob([this.s2ab(atob(resp.data.fileData))], {
          type: resp.data.fileType
        });
        const windowParams = `location=no,toolbar=no,menubar=no,width=800,height=1000,left=100,top=100`;

        window
          .open(
            URL.createObjectURL(file),
            `Предпросмотр сформированного оффера:blank`,
            windowParams
          )
          .focus();
        URL.revokeObjectURL(file);
      } else if (resp.data?.errors && resp.data?.errors.length) {
        this.showErrorMessage(resp.data.errors);
      }
      this.showOfferLoaderShow = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.offer-tab {
  padding: 24px;

  &__buttons {
    margin-bottom: 16px;
  }
}
</style>
